
import { defineComponent } from 'vue'
import { Service } from '@element-plus/icons'
import {
  CURRENT_PROJECT_SUBJECT,
  IS_AGENT_GENERAL_SUBJECT,
  IS_MING_TING_SUBJECT
} from '@/project-subject/project-subject'
import { IS_PRIVATE } from '@/common/const/env'
import { openQidianOnlineService } from '@/config/external-link'

export default defineComponent({
  components: {
    Service,
  },

  setup (props, context) {
    function clickOnlineService () {
      openQidianOnlineService()
    }

    return {
      IS_PRIVATE,
      CURRENT_PROJECT_SUBJECT,
      IS_MING_TING_SUBJECT,
      IS_AGENT_GENERAL_SUBJECT,
      clickOnlineService,
    }
  },
})
